import { Tabs } from 'antd'
import React from 'react'

import { StatisticsFeaturedJournal } from './statistics-featured-journal.component'
import { StatisticsLegacy } from './statistics.legacy'
import s from './statistics.module.less'
import { StatisticsProductUsage } from './statistics.product-usage.component'
import { StatisticsUserUsage } from './statistics.user-usage.component'

const StatisticsTab = {
  product: '产品用量',
  user: '个人用量',
  legacy: '遗留指标',
  featuredJournal: '精选周刊',
} as const
type StatisticsTabType = keyof typeof StatisticsTab

export const StatisticsContainer: React.FC = () => {
  const [tab, setTab] = React.useState<StatisticsTabType>('product')
  const tabs = (
    <Tabs activeKey={tab} onChange={(key) => setTab(key as typeof tab)}>
      {Object.keys(StatisticsTab).map((key) => (
        <Tabs.TabPane tab={StatisticsTab[key]} key={key} />
      ))}
    </Tabs>
  )

  const content = (() => {
    switch (tab) {
      case 'product':
        return <StatisticsProductUsage />
      case 'user':
        return <StatisticsUserUsage />
      case 'legacy':
        return <StatisticsLegacy />
      case 'featuredJournal':
        return <StatisticsFeaturedJournal />
    }
  })()

  return (
    <div className={s.statisticsContainer}>
      {tabs}
      {content}
    </div>
  )
}
